import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3" }
const _hoisted_2 = { class: "col-span-1 flex" }
const _hoisted_3 = { class: "m-4 space-y-4 flex flex-col" }
const _hoisted_4 = { class: "col-span-2" }
const _hoisted_5 = {
  key: 0,
  class: "m-4 mb-10"
}
const _hoisted_6 = { class: "text-left text-xl mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, [
  /*#__PURE__*/_createElementVNode("i", null, " Please note, if you make short changes, you must click the \"Calculate\" button again! ")
], -1)

import TheHeader from "@/components/TheHeader.vue";
import Input from "@/components/Form/Input.vue";
import Select from "@/components/Form/Select.vue";
import { ref } from "vue";
import axios from "axios";
import firstImage from "@/assets/images/surface-image.png";
import secondImage from "@/assets/images/module-coverage-image.png";

const something = "3S Price Indication Tool";
const inputTypeNumber = "number";

const labelSurface = "Roof/Facade Active Surface Area [m²] (max. 1000m²)";
const labelModelCoverage =
  "Module coverage loss factor (Crea/Adapto area) [%] (max. 25%)";
const labelSystemType = "System Type";
const labelModuleType = "Module Type";
const labelGlassType = "Glass Type";
const labelColourType = "Colour Type";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const token = process.env.VUE_APP_AUTH_TOKEN;
const apiUrl = process.env.VUE_APP_API_URL;
const isCalled = ref(false);
const apiResponse = ref(null);

// type of the input field
const surfaceInput = ref();

const modelCoverageInput = ref();

const systemTypeSelects = ref([
  { text: "Roof", value: "Roof" },
  { text: "Facade", value: "Facade" },
]);
const systemTypeSelected = ref();

const moduleTypeSelects = ref([
  { text: "MegaSlate", value: "MegaSlate" },
  { text: "TeraSlate", value: "TeraSlate" },
]);
const moduleTypeSelected = ref();

const glassTypeSelects = ref([
  { text: "Standard", value: "Standard" },
  { text: "Satinato", value: "Satinato" },
]);
const glassTypeSelected = ref();

const colourTypeSelects = ref([
  { text: "Black", value: "Black" },
  { text: "Flair (SX/DCP)", value: "Flair (SX/DCP)" },
]);
const colourTypeSelected = ref();

const creaAdapto = ref(false);
const aluSubConstruction = ref(false);
const roundedQuotationPrice = ref();
const quotationPriceTolerance = ref();
const roundedActiveArea = ref();
const roundedCreaModuleArea = ref();
const areaPrice = ref();
const kwpPrice = ref();

const displayedSurfaceInput = ref();
const displayedSystemTypeSelected = ref();
const displayedModuleTypeSelected = ref();
const displayedGlassTypeSelected = ref();
const displayedColourTypeSelected = ref();

const toggleRadio = (fieldName, currentValue) => {
  if (fieldName === "creaAdapto") {
    creaAdapto.value = creaAdapto.value === currentValue ? false : currentValue;
  } else if (fieldName === "aluSubConstruction") {
    aluSubConstruction.value =
      aluSubConstruction.value === currentValue ? false : currentValue;
  }
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const callAPI = async (async) => {
  try {
    displayedSurfaceInput.value = surfaceInput.value;
    displayedSystemTypeSelected.value = systemTypeSelected.value;
    displayedModuleTypeSelected.value = moduleTypeSelected.value;
    displayedGlassTypeSelected.value = glassTypeSelected.value;
    displayedColourTypeSelected.value = colourTypeSelected.value;
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        system_type: systemTypeSelected.value,
        module_type: moduleTypeSelected.value,
        glass_type: glassTypeSelected.value,
        colour_type: colourTypeSelected.value,
        crea_bool: creaAdapto.value,
        alu_bool: aluSubConstruction.value,
        roof_area: surfaceInput.value,
        coverage_factor: modelCoverageInput.value,
      },
    });
    apiResponse.value = response.data;

    roundedQuotationPrice.value =
      Math.ceil(apiResponse.value.quotation_price / 100) * 100;

    quotationPriceTolerance.value = Math.round(
      roundedQuotationPrice.value / 10
    );

    roundedActiveArea.value = Math.round(apiResponse.value.area);

    roundedCreaModuleArea.value = Math.round(
      apiResponse.value.crea_module_area
    );

    areaPrice.value = Math.round(
      roundedQuotationPrice.value / surfaceInput.value
    );

    kwpPrice.value = Math.round(
      roundedQuotationPrice.value / apiResponse.value.estimated_kwp
    );

    isCalled.value = true;
    // surfaceInput.value = null;
    // modelCoverageInput.value = null;
    // systemTypeSelected.value = null;
    // moduleTypeSelected.value = null;
    // glassTypeSelected.value = null;
    // colourTypeSelected.value = null;
  } catch (error) {
    if (error.response) {
      // Der Server antwortete mit einem Status außerhalb des Bereichs von 2xx
      console.log("Error 1" + error.response.data);
      console.log("Error 2" + error.response.status);
      console.log("Error 3" + error.response.headers);
    } else if (error.request) {
      // Die Anfrage wurde gemacht, aber keine Antwort wurde empfangen
      console.log("Error 4" + error.request);
    } else {
      // Ein Fehler wurde beim Setup der Anfrage ausgelöst
      console.log("Error", error.message);
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TheHeader, { "title-name": something }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Input, {
            "model-value": surfaceInput.value,
            "type-value": inputTypeNumber,
            "label-value": labelSurface,
            "has-icon": true,
            "image-src": _unref(firstImage),
            "max-value": 1000,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (surfaceInput.value = $event))
          }, null, 8, ["model-value", "image-src"]),
          _createVNode(Input, {
            "model-value": modelCoverageInput.value,
            "type-value": inputTypeNumber,
            "label-value": labelModelCoverage,
            "has-icon": true,
            "image-src": _unref(secondImage),
            "max-value": 25,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (modelCoverageInput.value = $event))
          }, null, 8, ["model-value", "image-src"]),
          _createVNode(Select, {
            "label-value": labelSystemType,
            modelValue: systemTypeSelected.value,
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = ($event: any) => ((systemTypeSelected).value = $event)),
              _cache[3] || (_cache[3] = ($event: any) => (systemTypeSelected.value = $event))
            ],
            options: systemTypeSelects.value
          }, null, 8, ["modelValue", "options"]),
          _createVNode(Select, {
            "label-value": labelModuleType,
            modelValue: moduleTypeSelected.value,
            "onUpdate:modelValue": [
              _cache[4] || (_cache[4] = ($event: any) => ((moduleTypeSelected).value = $event)),
              _cache[5] || (_cache[5] = ($event: any) => (moduleTypeSelected.value = $event))
            ],
            options: moduleTypeSelects.value
          }, null, 8, ["modelValue", "options"]),
          _createVNode(Select, {
            "label-value": labelGlassType,
            modelValue: glassTypeSelected.value,
            "onUpdate:modelValue": [
              _cache[6] || (_cache[6] = ($event: any) => ((glassTypeSelected).value = $event)),
              _cache[7] || (_cache[7] = ($event: any) => (glassTypeSelected.value = $event))
            ],
            options: glassTypeSelects.value
          }, null, 8, ["modelValue", "options"]),
          _createVNode(Select, {
            "label-value": labelColourType,
            modelValue: colourTypeSelected.value,
            "onUpdate:modelValue": [
              _cache[8] || (_cache[8] = ($event: any) => ((colourTypeSelected).value = $event)),
              _cache[9] || (_cache[9] = ($event: any) => (colourTypeSelected.value = $event))
            ],
            options: colourTypeSelects.value
          }, null, 8, ["modelValue", "options"]),
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              value: true,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((creaAdapto).value = $event)),
              onClick: _cache[11] || (_cache[11] = ($event: any) => (toggleRadio('creaAdapto', true)))
            }, null, 512), [
              [_vModelRadio, creaAdapto.value]
            ]),
            _createTextVNode(" Crea/Adapto ")
          ]),
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              value: true,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((aluSubConstruction).value = $event)),
              onClick: _cache[13] || (_cache[13] = ($event: any) => (toggleRadio('aluSubConstruction', true)))
            }, null, 512), [
              [_vModelRadio, aluSubConstruction.value]
            ]),
            _createTextVNode(" ALU sub-construction ")
          ]),
          _createElementVNode("button", {
            class: "bg-red-700 rounded-md max-w-32 text-white",
            onClick: callAPI
          }, " Calculate ")
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (isCalled.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("h1", _hoisted_6, _toDisplayString(displayedSystemTypeSelected.value) + " - " + _toDisplayString(displayedModuleTypeSelected.value) + " - " + _toDisplayString(displayedGlassTypeSelected.value) + " - " + _toDisplayString(displayedColourTypeSelected.value), 1),
              (apiResponse.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("p", null, [
                      _createTextVNode(" PV system active area = " + _toDisplayString(displayedSurfaceInput.value) + " m", 1),
                      _hoisted_8
                    ]),
                    _createElementVNode("p", null, [
                      _createTextVNode(" Standard module coverage area = " + _toDisplayString(roundedActiveArea.value) + " m", 1),
                      _hoisted_9
                    ]),
                    (displayedSystemTypeSelected.value === 'Roof')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                          _createTextVNode(" Crea module area = " + _toDisplayString(roundedCreaModuleArea.value) + " m", 1),
                          _hoisted_11
                        ]))
                      : (displayedSystemTypeSelected.value === 'Facade')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                            _createTextVNode(" Adapto module area = " + _toDisplayString(roundedCreaModuleArea.value) + " m", 1),
                            _hoisted_13
                          ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("p", null, [
                      _createTextVNode(" Estimated quotation price (net price with all standard components): "),
                      _createElementVNode("b", null, _toDisplayString(roundedQuotationPrice.value) + " CHF", 1),
                      _createTextVNode(" (+/- " + _toDisplayString(quotationPriceTolerance.value) + " CHF) ", 1)
                    ]),
                    _createElementVNode("p", null, [
                      _createTextVNode(" Estimated kWp: "),
                      _createElementVNode("b", null, _toDisplayString(apiResponse.value.estimated_kwp) + " kWp", 1)
                    ]),
                    _createElementVNode("p", null, [
                      _createTextVNode("Price per m"),
                      _hoisted_14,
                      _createTextVNode(": ~ " + _toDisplayString(areaPrice.value) + " CHF/m", 1),
                      _hoisted_15
                    ]),
                    _createElementVNode("p", null, "Price per kWp: ~ " + _toDisplayString(kwpPrice.value) + " CHF/kWp", 1),
                    _hoisted_16
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})